import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

// layout constants
import { LayoutTypes } from '../constants/layout';

// strore
import { RootState } from '../redux/store';


// All layouts containers
import DefaultLayout from '../layouts/Default';
import VerticalLayout from '../layouts/Vertical';
import DetachedLayout from '../layouts/Detached';
import HorizontalLayout from '../layouts/Horizontal/';
import TwoColumnLayout from '../layouts/TwoColumn/';

import { authProtectedFlattenRoutes, publicProtectedFlattenRoutes } from './index';

// Super Admin Module
import AdminLayout from '../layouts/AdminLayout';
import AdminPrivateRoute from './AdminPrivateRoute';
import { adminProtectedRoutes } from './adminRoutes';
import { adminAuth } from '../helpers/api/adminApi';

const AdminLogin = React.lazy(() => import('../pages/admin/auth/AdminLogin'));

interface RoutesProps { }

const Routes = (props: RoutesProps) => {
    const { layout } = useSelector((state: RootState) => ({
        layout: state.Layout,
    }));

    const getLayout = () => {
        let layoutCls = TwoColumnLayout;

        switch (layout.layoutType) {
            case LayoutTypes.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case LayoutTypes.LAYOUT_DETACHED:
                layoutCls = DetachedLayout;
                break;
            case LayoutTypes.LAYOUT_VERTICAL:
                layoutCls = VerticalLayout;
                break;
            default:
                layoutCls = TwoColumnLayout;
                break;
        }
        return layoutCls;
    };

    let Layout = getLayout();

    return (
        <BrowserRouter>
            <Switch>
                {/* ── SUPER ADMIN ISOLATED MODULE (Zero Contamination) ── */}
                <Route path="/admin/login" exact>
                    <React.Suspense fallback={<div className="p-5 text-center text-muted">Loading Admin Console...</div>}>
                        {adminAuth.isAuthenticated() ? (
                            <Redirect to="/admin/dashboard" />
                        ) : (
                            <AdminLogin />
                        )}
                    </React.Suspense>
                </Route>

                <Route path="/admin">
                    <React.Suspense fallback={<div className="p-5 text-center text-muted">Loading Admin Module...</div>}>
                        <AdminLayout>
                            <Switch>
                                {adminProtectedRoutes.map((route, index) => (
                                    <AdminPrivateRoute
                                        key={index}
                                        path={route.path}
                                        exact={route.exact}
                                        component={route.component}
                                        permission={route.permission}
                                    />
                                ))}
                                <Redirect from="/admin" exact to="/admin/dashboard" />
                                <Redirect to="/admin/dashboard" />
                            </Switch>
                        </AdminLayout>
                    </React.Suspense>
                </Route>

                <Route path={publicProtectedFlattenRoutes.map((r: any) => r['path'])}>
                    <DefaultLayout {...props} layout={layout}>
                        <Switch>
                            {publicProtectedFlattenRoutes.map((route: any, index: number) => {
                                return (
                                    !route.children && (
                                        <route.route
                                            key={index}
                                            path={route.path}
                                            roles={route.roles}
                                            exact={route.exact}
                                            component={route.component}
                                        />
                                    )
                                );
                            })}

                            {/* FALLBACK FOR PUBLIC ROUTES */}
                            <Route path="*">
                                <Redirect to="/auth/login" />
                            </Route>
                        </Switch>
                    </DefaultLayout>
                </Route>

                <Route path={authProtectedFlattenRoutes.map((r: any) => r['path'])}>
                    <Layout {...props}>
                        <Switch>
                            {authProtectedFlattenRoutes.map((route: any, index: number) => {
                                return (
                                    !route.children && (
                                        <route.route
                                            key={index}
                                            path={route.path}
                                            roles={route.roles}
                                            exact={route.exact}
                                            component={route.component}
                                        />
                                    )
                                );
                            })}

                            {/* FALLBACK FOR AUTH ROUTES */}
                            <Route path="*">
                                <Redirect to="/auth/login" />
                            </Route>
                        </Switch>
                    </Layout>
                </Route>

                {/* GLOBAL FALLBACK */}
                <Route path="*">
                    <Redirect to="/auth/login" />
                </Route>
            </Switch>
        </BrowserRouter>

    );
};

export default Routes;
